import { OPTION_TYPE } from "Common/dictionaries/optionType";
import filter from "lodash/filter";
import { compareStrings } from "Utils";
export const getNodeUrl = (node, documentObject) => {
    var _a, _b, _c;
    if (!node || !documentObject || !documentObject.Attributes)
        return "";
    const stringAttr = filter(documentObject.Attributes, ["Type", OPTION_TYPE.STRING]);
    const stringAttrText = (_a = stringAttr.find(item => compareStrings(item.Name, ["url", "link"]))) === null || _a === void 0 ? void 0 : _a.Key;
    if (stringAttrText) {
        const value = (_c = (_b = node.AttributeValues) === null || _b === void 0 ? void 0 : _b.find(item => item.Key === stringAttrText)) === null || _c === void 0 ? void 0 : _c.Value;
        if (value)
            return `${value}`;
    }
    return undefined;
};
